export default __webpack_public_path__ + "c59ab70d56a56600b1ee04602c430cd2.png";